import React from "react";
import { NavLink } from "react-router-dom";

const PageHeading = ({ title, breadcrumbs = [] }) => {
  if (!title) return null;

  return (
    <div className="np-page-heading-block">
      <h1 className="np-admin-page-heading mb-0">{title}</h1>
      <nav aria-label="Breadcrumb">
        <ol className="breadcrumb np-admin-breadcrumb mb-0">
          {title !== "Dashboard" && (
            <li className="breadcrumb-item">
              <NavLink to="/">Home</NavLink>
            </li>
          )}
          {breadcrumbs.map((breadcrumb) => (
            <li className="breadcrumb-item" key={`${breadcrumb.label}-${breadcrumb.to || "current"}`}>
              {breadcrumb.to ? (
                <NavLink to={breadcrumb.to}>{breadcrumb.label}</NavLink>
              ) : (
                <span>{breadcrumb.label}</span>
              )}
            </li>
          ))}
          <li className="breadcrumb-item active" aria-current="page">
            {title}
          </li>
        </ol>
      </nav>
    </div>
  );
};

export default PageHeading;